<!-- begin:: Header Topbar -->
<div class="kt-header__topbar">  
   <div  *ngxPermissionsOnly="[PermissionsLables.ReviewsReceiveNotification]"> <span   *ngIf="showBadge" matBadge="{{BadgeNumber}}" [matBadgeOverlap]="false"></span>
    <notification   [bgImage]="'./assets/media/misc/bg-1.jpg'" [pulse]="true" [skin]="'dark'" 
                  [userNotificationsList]="userNotificationsList" [icon]="'./assets/media/icons/svg/Code/Compiling.svg'"
                  [useSVG]="true" (scolled)="getNotification($event)" (readNotification)="readNotification($event)" (readAllNotification)="readAllNotification($event)"></notification>

</div>
    <user-profile></user-profile>
</div>

<!-- end:: Header Topbar -->
    